import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Theme} from '@emotion/react';

const styledSection = ({theme}: {theme: Theme}) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.gap.desktop.xl};
`;

export const SectionPaymentsDesktopWrapper = styled.div`
  ${styledSection};
  padding: ${({theme}) => theme.padding.desktop.md};
`;

export const SectionPaymentsMobileWrapper = styled.div`
  ${styledSection};
`;
